import { render, staticRenderFns } from "./About.vue?vue&type=template&id=b6e0b93a&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=b6e0b93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e0b93a",
  null
  
)

export default component.exports